import Axios from 'axios';
import { createStandardResponse, StandardResponse } from '../../models/standard-response';
import type { IOpenSource } from 'models/open-source';
import { env } from 'config/env';

export const getOpenSourceData = async (): Promise<StandardResponse<IOpenSource>> => {
  try {
    const res = await Axios.get(`${env.VITE_API_SERVER}/common/driver/public/information/open-source`);
    return createStandardResponse<IOpenSource>(res.status, res.data.data, res.data.message, null);
  } catch (e) {
    return Promise.reject(e);
  }
};
